<template>
<div class="chapter">
<div class="inner_page">
<h1 class="P_Heading_1" id="auto_bookmark_toc_1"><span>Driven to Distraction</span></h1>
<p class="P_Normal"> </p>
<p class="P_Norm-NoIndent">By Cassie Decker</p>
<p class="P_Normal"> </p>
<p class="P_Normal">Cowboys Wyatt and Brady are competing in a team-roping event in Missoula, Montana’s annual Christmas Eve rodeo. Christmas is Wyatt’s favorite time of year and nothing is going to dampen his holiday spirit, not even his surly, no-nonsense roping partner. They’ve only been riding together for a week, but Wyatt has already secretly fallen head over bootheels for Brady, though it’s painfully obvious Brady only has eyes for the rodeo’s grand prize purse.</p>
<p class="P_Normal">When Brady is distracted during a crucial moment in the night’s first roping run and nearly disqualifies them, Wyatt is almost certain he is going to be another of Brady’s many rejected partners. Will Wyatt and Brady be able to sort out their differences and work together to win the grand prize? Maybe, if Wyatt can show Brady that Christmas really is a time for miracles.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0001.vue?7297052a